// extracted by mini-css-extract-plugin
export default {"container":"GraphPeriodStyle_container__k1HDm","period":"GraphPeriodStyle_period__ZddTA","active":"GraphPeriodStyle_active__VKChd"};